import { ReactElement } from 'react'
import {
	useEquipmentMakeByIdQuery,
	useEquipmentModelByIdQuery,
} from '../../../../../graphql'

type Props = {
	makeId: number | null,
	modelId: number | null,
}

// Resolves a (makeId, modelId) pair to "Make Name Model Name" via the ES core
// REST API. Renders empty (suitable for inline composition) until names load.
export default function EquipmentMakeModelLabel( { makeId, modelId }: Props ): ReactElement | null {
	const { data: makeData } = useEquipmentMakeByIdQuery( {
		variables: { id: makeId ?? 0 },
		skip: !makeId,
		errorPolicy: 'ignore',
	} )
	const { data: modelData } = useEquipmentModelByIdQuery( {
		variables: { id: modelId ?? 0 },
		skip: !modelId,
		errorPolicy: 'ignore',
	} )

	const makeName = makeData?.equipmentMake?.name ?? null
	const modelName = modelData?.equipmentModel?.name ?? null

	if ( !makeName && !modelName ) {
		return null
	}
	const parts = [ makeName, modelName ].filter( Boolean ).join( ' ' )
	return <>{parts}</>
}
